import React, { useEffect, useState, useRef, useCallback } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import Lib from 'library'
import { useLocation, useNavigate } from 'react-router-dom'
import useSecureKeypad from 'hooks/useSecureKeypad'

const DataPw = () => {

	const App = useApp()
	const [passwordValue, setPasswordValue] = useState("")
	const [module, showKeypad] = useSecureKeypad()
	const [passwordLength, setPasswordLength] = useState(0);
	const navigate = useNavigate()
	const passwordInfo = useRef(null)

	const [passError, setPassError] = useState(false)
	const [passMsg, setPassMsg] = useState("")
	const [disable, setDisabled] = useState(true);

	const location = useLocation();
	const sno = location?.state?.sno || "220504144538035" // TODO: 실제 앱 테스트 시 (220425194448956) 삭제

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	const pass = useRef(null)

	// 비밀번호 입력
	const clickPwInput = (e) => {
		e.target.value = ""

		showKeypad({
			input: e.target,
			onShow: () => {
				//setPasswordCheck(false)
			},
			onChange: (length) => {
				const info = module.get_sessionInfo();
				pass.current = info

				setPassError(false)
				setPasswordLength(length)
				
				setDisabled(length !== 6)

				// if (length === 6){
				// 	Lib.post({
				// 		url: `/api/data/crtf/view/${sno}`,
				// 		onSuccess: data => {
				// 			console.log(`onSuccess: ${data}`)
				// 		},
				// 		onFail: res => {
				// 			setPassError(true)
				// 			setPassMsg(res.msg)
				// 		},
				// 		onError: ({ res }) => {
				// 			if (!res) {
				// 				App.alert("응답이 없습니다.")
				// 				return
				// 			}
				// 			console.log(res.data.code, res.data.msg)
				// 			let msg
				// 			if (res.data.msg) {
				// 				msg = `${res.data.code}: ${res.data.msg}`
				// 			} else {
				// 				msg = "알수 없는 오류가 발생했습니다.<br />다시 시도해 주세요."
				// 			}
				// 			App.alert(msg)
				// 		},
				// 		onComplete: res => {
				// 			console.log(res)
				// 		},
				// 		data: {
				// 			"pw": module.get_input() || "",
				// 			"secId": pass.current.secId,
				// 			"secInput": pass.current.secInput,
				// 			"secToken": pass.current.secInput
				// 		}
				// 	})
				// }
				
				// setPasswordValue(module.get_input())
				// setPasswordCheck(length === 6)
			}
		})
	}

	const onNext = useCallback(()=>{
		Lib.post({
			url: `/api/data/crtf/view/${sno}`,
			onSuccess: shareData => {
				console.log(`onSuccess: ${shareData}`)
				//TODO: 공유받은 데이터 증명서 비밀번호 입력 성공 후 화면 
				navigate("/home/DataDetail", {state: shareData})
			},
			onFail: res => {
				setPassError(true)
				setPassMsg(res.msg)

				if (res.code === "E001") { // 패스워드 불일치
					if (res.desc === 5) {
						setPassMsg(`비밀번호를 ${res.desc}회 이상 틀려<br />증명서를 열람할 수 없어요.<br />증명서를 다시 요청 및 열람 해주세요.`)
						return true
					}
					setPassMsg(`비밀번호 ${res.desc}회 틀리셨어요.`)
				} else if (res.code === "E002") { // 유효기간 만료
					navigate("/home/dataPwTimeOut")
				} else if (res.code === "E003") { // 공유한 회원 탈퇴
					navigate("/home/dataPwError")
				} else if (res.code === "E009") { // 일련번호 해당하는 증명서 X
					navigate("/home/dataPwError")
				}
			},
			onError: ({ res }) => {
				if (!res) {
					App.alert("응답이 없습니다.")
					return
				}
				console.log(res.data.code, res.data.msg)
				let msg
				if (res.data.msg) {
					msg = `${res.data.code}: ${res.data.msg}`
				} else {
					msg = "알수 없는 오류가 발생했습니다.<br />다시 시도해 주세요."
				}
				App.alert(msg)
			},
			onComplete: res => {
				// navigate("/home/dataPwTimeOut")
				console.log({res})
			},
			data: {
				"pw": module.get_input() || "", // TODO: 실제 앱 테스트 진행시 삭제
				"secId": pass.current.secId,
				"secInput": pass.current.secInput,
				"secToken": pass.current.secInput
			}
		})
	}, [])
	
	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<i className="icon icon_password_intro" />
				<h3 className="intro-tit mt_30">비밀번호 6자리 입력 ({passwordLength}/6)</h3>
				<p className="intro-sub-tit mt_10">공유받은 비밀번호를 입력하세요.</p>
				<div className="password-box mt_40" style={{position: 'relative'}}>
					<input
						ref={passwordInfo}
						type="password"
						style={{
							position: 'absolute',
							top: '0', 
							left: '0',
							zIndex: '100',
							width: '100%',
							opacity: 0,
						}}
						onClick={clickPwInput}
					/>
					
					{Array.apply(null, Array(6)).fill(undefined).map((emt, index) => <span key={index} className={passwordLength > index ? "on" : ""} />)}
					
					{/* <span className="on" />
					<span className="on" />
					<span />
					<span />
					<span />
					<span /> */}
				</div>
				
				{/* <div className="text-red text-align_center mt_20">비밀번호를 1회 틀리셨어요.</div> */}
				{passError && <div className="text-red text-align_center mt_20">{passMsg}</div>}
			</div>
			<div className="padding flex-shrink_0 pt_0">
				<Button className="btn btn--big" disable={disable} onClick={onNext}>다음</Button>
			</div>
		</div>
	)
}

export default DataPw
